<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.title}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <file-select
          :offset-wrapper-col="offsetWrapperCol"
          :decorators="decorators"
          download-url="/v2/batch-import/skumap" />
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import FileSelect from '../components/FileSelect'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'TemplateImportDialog',
  components: {
    FileSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  provide () {
    return {
      form: this.form,
    }
  },
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        file: [
          'file',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('op_23') },
              { validator: this.validateFile },
            ],
          },
        ],
      },
      offsetWrapperCol: {
        span: 24,
        // offset: 3,
        xxl: {
          span: 24,
          // offset: 2,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
  },
  methods: {
    validateFile (rule, value, callback) {
      if (value) {
        if (value.file && !value.file.name.endsWith('.xlsx')) {
          const error = this.$t('op_24')
          return callback(error)
        }
      }
      return callback()
    },
    doImport (data) {
      const fd = new FormData()
      fd.append('action', 'skumap')
      fd.append('skumap', new Blob([data.file.file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      return new this.$Manager('batch-import').create({
        data: fd,
      }).catch(error => {
        this.$bus.$emit('OriginalSKUImportFileSelectClear')
        throw error
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doImport(values)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
